import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    <Link to="/" className="logo" aria-label="Napho - home">
      <span className="logo__word">Napho</span>
      <span className="logo__dot" aria-hidden />
    </Link>
  );
}
